import { c as _c } from "react/compiler-runtime";
import { StarIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useGithubStats } from '@/hooks/queries/stats.query';
import { useFormatNumber } from '@/hooks/use-format-number';
import { Link } from '../ui/link';
import { Separator } from '../ui/separator';
export function GithubStarButton() {
  const $ = _c(13);
  const {
    data,
    isSuccess,
    isLoading,
    isError
  } = useGithubStats();
  const t = useTranslations();
  const format = useFormatNumber();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-8 items-center gap-2 bg-muted pr-2 pl-3 font-medium"><StarIcon className="size-4" /> Star</div>;
    t1 = <Separator orientation="vertical" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data || $[3] !== format || $[4] !== isSuccess) {
    t2 = isSuccess && format(data.repoStars);
    $[2] = data;
    $[3] = format;
    $[4] = isSuccess;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isLoading && "--";
  let t4;
  if ($[6] !== isError || $[7] !== t) {
    t4 = isError && t("common.error");
    $[6] = isError;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Link href="https://github.com/braviaprime/braviaprime.com" className="flex items-center overflow-hidden rounded-4xl border">{t0}{t1}<div className="flex h-8 items-center bg-background pr-3 pl-2">{t2}{t3}{t4}</div></Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}